import React, { FC, useRef, useState } from "react";
import Slider from "react-slick";
import MediaItem from "./MediaItem";
import FullScreen from "./FullScreen";
import { ImageData } from "../../../store/types/strapi-types";

const baseUrl =
  process.env.REACT_APP_STRAPI_IMAGES_URL?.replace(/\/$/, "") || "";

interface Props {
  videoUrl?: string;
  images: null | ImageData[];
  floorPlans: null | ImageData[];
}

const getOriginalUrl = (img: ImageData) => baseUrl + img.attributes.url;

const ProjectGallery: FC<Props> = ({ videoUrl, images, floorPlans }) => {
  const sliderRef = useRef<any>(null);
  const [fullscreenMedia, setFullscreenMedia] = useState<number | null>(null);

  const mediaItems = [
    ...(videoUrl
      ? [
          {
            id: -1,
            description: "Project Video",
            imgUrl: videoUrl,
            videoUrl: videoUrl,
          },
        ]
      : []),
    ...(images?.map((img) => ({
      id: img.id,
      description: img.attributes.alternativeText || "Image",
      imgUrl: getOriginalUrl(img),
    })) || []),
    ...(floorPlans?.map((img) => ({
      id: img.id,
      description: img.attributes.alternativeText || "Floor Plan",
      imgUrl: getOriginalUrl(img),
    })) || []),
  ];

  const nextSlide = () => {
    sliderRef.current?.slickNext();
  };

  const prevSlide = () => {
    sliderRef.current?.slickPrev();
  };

  return (
    <div className="property-image-gallery mb-[7rem] relative h-[600px] bg-white w-full transition-opacity duration-500">
      {mediaItems.length === 0 ? (
        <div className="w-full h-full flex items-center justify-center">
          <h6 className="text-black">No Media Available</h6>
        </div>
      ) : mediaItems.length === 1 ? (
        <img
          src={mediaItems[0].imgUrl}
          alt={mediaItems[0].description}
          className="w-full h-full object-cover "
        />
      ) : (
        <>
          {/* @ts-ignore */}
          <Slider
            ref={sliderRef}
            speed={500}
            slidesToShow={1}
            slidesToScroll={1}
            dots
            infinite
            variableWidth
            swipe={false}
            arrows={false}
            className="relative"
          >
            {mediaItems.map((media, index) => (
              <MediaItem
                key={index}
                openModal={() => setFullscreenMedia(index)}
                isLoaded={true}
                onLoadingComplete={() => {}}
                {...media}
              />
            ))}
          </Slider>

          <button
            className="absolute -left-10 top-1/2 transform -translate-y-1/2 w-[10rem] h-[10rem] flex items-center justify-center"
            onClick={prevSlide}
          >
            <div className="bg-gray-700 text-white w-14 h-14 rounded-full flex items-center justify-center hover:bg-gray-800 shadow-lg">
              ◀
            </div>
          </button>

          <button
            className="absolute -right-10 top-1/2 transform -translate-y-1/2 w-[10rem] h-[10rem]  flex items-center justify-center"
            onClick={nextSlide}
          >
            <div className="bg-gray-700 text-white w-14 h-14 rounded-full flex items-center justify-center hover:bg-gray-800 shadow-lg">
              ▶
            </div>
          </button>

          {fullscreenMedia !== null && (
            <FullScreen
              medias={mediaItems}
              initSlideIndex={fullscreenMedia}
              closeModal={() => setFullscreenMedia(null)}
            />
          )}
        </>
      )}
    </div>
  );
};

export default ProjectGallery;
